// Phase to Status Mapping
// Maps subitem phase values (with number prefixes) to modeling status values
export const PHASE_STATUS_MAP = {
  "00-Startup": "Startup",
  "01-Data Prep": "Data Prep",
  "02-Utilities": "Utilities",
  "03-Discrepancy Check": "Data Prep", // Phase kept for subitems, maps to Data Prep status
  "04-Erosion/Pond": "Ready to Model", // Phase kept for subitems, maps to Ready to Model status (Erosion/Pond modeling status removed)
  "05-Modeling": "Modeling",
  "06-Double Check": "Double Check",
  "07-Corrections": "Corrections",
  "08-Review": "Review",
  "09-Ready to Export": "Ready to Export",
  "10-Completed": "Completed",
  // Additional phases found in subitems
  "Export, Send, and Invoice": "Export, Send, and Invoice",
  "Model Building": "Model Building",
  "Project Auditing": "Project Auditing",
  "Project Startup": "Project Startup",
  "Revision": "Revision"
};

// Reverse mapping for quick lookups
export const STATUS_TO_PHASE_MAP = Object.entries(PHASE_STATUS_MAP).reduce((acc, [phase, status]) => {
  if (!acc[status]) {
    acc[status] = [];
  }
  acc[status].push(phase);
  return acc;
}, {});

// Helper function to get all phases that map to a given status
export const getPhasesForStatus = (modelingStatus) => {
  return STATUS_TO_PHASE_MAP[modelingStatus] || [];
};

// Helper function to get status from phase
export const getStatusFromPhase = (phase) => {
  return PHASE_STATUS_MAP[phase] || null;
};

// Helper function to get single phase string for a modeling status
// Returns the first/primary phase for the status (needed for SubitemsTable logic)
export const getPhaseForStatus = (modelingStatus) => {
  const phases = STATUS_TO_PHASE_MAP[modelingStatus];
  return phases && phases.length > 0 ? phases[0] : null;
};

// Phase order for consistent ordering across components
export const PHASE_ORDER = [
  "00-Startup",
  "01-Data Prep",
  "02-Utilities",
  "03-Discrepancy Check",
  "04-Erosion/Pond",
  "05-Modeling",
  "06-Double Check",
  "07-Corrections",
  "08-Review",
  "09-Ready to Export",
  "10-Completed",
  // Additional phases
  "Project Startup",
  "Model Building",
  "Project Auditing",
  "Export, Send, and Invoice",
  "Revision"
];